import React, {
  memo, useCallback, useEffect, useRef,
} from 'react'

import {
  arrayOf, func, shape, string,
} from 'prop-types'

import { FEATURES } from 'Pods/SearchPage/Shared/FeaturesContent/constants'
import FeaturesContent from 'Pods/SearchPage/Shared/FeaturesContent/FeaturesContent'
import useTranslate from 'Pods/SearchPage/Shared/useTranslate'
import { useSearchPageStore } from 'Pods/SearchPage/Store/index'
import FiltersWrapper from 'Pods/Shared/FiltersWrapper/FiltersWrapper'

export const SEARCH_FOCUS_DELAY = 300

function Features({ features = FEATURES }) {
  const t = useTranslate()

  const searchRef = useRef(null)
  const focusTimerRef = useRef(null)
  const selectedCount = useSearchPageStore(useCallback(
    state => features.filter(feature => feature.select(state)).length,
    [features],
  ))

  useEffect(() => {
    return () => {
      if (focusTimerRef.current) clearTimeout(focusTimerRef.current)
    }
  }, [])

  const hasSelectedAnyFilters = selectedCount > 0
  const placeholder = hasSelectedAnyFilters
    ? t('search_page.filters.features.title_with_count', { count: selectedCount })
    : t('search_page.filters.features.title')
  const reservedPlaceholder = t('search_page.filters.features.title_with_count', { count: features.length })

  const handleOpenChange = useCallback((isOpen) => {
    // Cancel any pending focus first so a fast close-before-delay doesn't steal focus.
    if (focusTimerRef.current) clearTimeout(focusTimerRef.current)
    if (!isOpen || !searchRef.current) return
    // Wait past ClosingDropdown's 200ms open animation before focusing; matches Style.jsx.
    focusTimerRef.current = setTimeout(() => {
      searchRef.current?.focus()
    }, SEARCH_FOCUS_DELAY)
  }, [])

  return (
    <FiltersWrapper
      placeholder={placeholder}
      reservedPlaceholder={reservedPlaceholder}
      content={<FeaturesContent features={features} searchInputRef={searchRef} />}
      onOpenChange={handleOpenChange}
      hasSelectedAnyFilters={hasSelectedAnyFilters}
      closingDropdownClassName="filter-wrapper"
    />
  )
}

Features.propTypes = {
  features: arrayOf(shape({
    value: string.isRequired,
    labelKey: string.isRequired,
    select: func.isRequired,
    onChange: func.isRequired,
  })),
}

export default memo(Features)
